// extracted by mini-css-extract-plugin
export var divider = "_io-7";
export var itemsToggle = "_io-8";
export var mergeModal = "_io-1";
export var optionCard = "_io-4";
export var radioGroup = "_io-6";
export var radioOption = "_io-0";
export var selected = "_io-5";
export var shipmentOptions = "_io-2";
export var tableOptions = "_io-3";